import MarkupNav from "./MarkupNav";
import Header from "../Header/Header";
import ProductMarkup from "./ProductMarkup";

export default function Markup({ path, type }) {
  return (
    <>
     <div className="fixedHeader">
      <Header />
      <MarkupNav />
     </div>
     <div className="shadow"></div>
      <ProductMarkup path={path} type={type} />
    </>
  );
}
